import type { ButtonProps } from '~/components/Button/Button';
import Button, {
  AlternativeButton,
  DangerAlternativeButton,
  DangerButton,
  GreyPrimaryAlternativeButton,
  LightGrayPrimaryAlternativeButton,
  PrimaryAlternativeButton,
  PrimaryBlueButton,
  PrimaryButton,
  PrimaryGreyButton,
  SecondaryButton,
  SmallPrimaryButton,
} from '~/components/Button/Button';
import {
  GreyPrimaryAlternativeLink,
  PrimaryAlternativeExternalLink,
  PrimaryAlternativeLink,
  PrimaryAlternativePaintedExternalLink,
  PrimaryAlternativePaintedLink,
  PrimaryExternalLink,
  PrimaryLink,
  SmallPrimaryExternalLink,
} from '~/components/Button/ButtonLink';
import { buttons, ButtonTypes } from '~/components/Button/constants';

export default Button;

export {
  PrimaryButton,
  PrimaryBlueButton,
  PrimaryAlternativeButton,
  PrimaryGreyButton,
  AlternativeButton,
  GreyPrimaryAlternativeButton,
  GreyPrimaryAlternativeLink,
  DangerButton,
  DangerAlternativeButton,
  SecondaryButton,
  ButtonProps,
  PrimaryAlternativeLink,
  PrimaryAlternativeExternalLink,
  PrimaryLink,
  PrimaryExternalLink,
  SmallPrimaryExternalLink,
  PrimaryAlternativePaintedLink,
  PrimaryAlternativePaintedExternalLink,
  SmallPrimaryButton,
  ButtonTypes,
  buttons,
  LightGrayPrimaryAlternativeButton,
};
